export { default as KnowYourCostumer } from './know-your-costumer';
